<script>
    import AutocompleteNew from "../../components/Form/AutocompleteNew.svelte";
    let selectedCity = "";
</script>
<AutocompleteNew
    label="Şehir"
    fieldName="city"
    options={["İstanbul", "Ankara", "İzmir", "Bursa"]}
    bind:value={selectedCity}
    onChange={(val) => console.log('Seçilen:', val)}
    placeholder="Şehir seçin veya yazın"
/>